import {
  Box,
  Popover,
  Typography,
  Skeleton,
  useTheme,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setCombinationWidgetData,
  setFreeTablesData,
  setIsBackToHoreca,
  updateReservationGroup,
  updateTime,
} from "../../store/slice/Addguest.slice";

const TimeSlots = ({ isOpen, handleClose, Ref, name, onChange }) => {
  const theme = useTheme();
  const { webshopTimeSlots, deliverySlots } = useSelector(
    (store) => store?.Webshop
  );
  const [time, setime] = useState("");

  useEffect(()=>{  
    if(!time){
      setime(deliverySlots[0]?.deliveryTime);
      onChange(name,deliverySlots[0]?.deliveryTime);
    }
  },[time])
  return (
    <Popover
      open={isOpen}
      anchorEl={Ref}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <Box
        sx={{ width: "484px", backgroundColor: theme?.time?.bgColor, p: 2 }}
        className="times"
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            my: 2,
          }}
        >
          <Typography
            sx={{
              color: theme?.time?.itemTextColor,
              fontSize: "14px",
              fontWeight: "bold",
            }}
          >
            Select Delivery Time
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            //  justifyContent: "ce",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "1rem",
          }}
        >
          <>
        
          {deliverySlots?.map((item, index) => (
            <Tooltip key={index}>
              <Box
                sx={{
                  width: "137px",
                  height: "51px",
                  border: "1px solid",
                  borderColor: "grey",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  transition: "background-color 0.3s ease",
                  borderRadius: "5px",
                  backgroundColor:
                    time === item?.deliveryTime ? "grey" : "#fff",
                  color: time === item?.deliveryTime ? "#fff" : "grey",
                  "&:hover": {
                    backgroundColor: "lightgrey",
                    "& .text": {
                      color: "black",
                    },
                  },
                  opacity: !item?.isAvailable ? 0.5 : 1, // Optional: dim locked items
                  pointerEvents: item?.isAvailable ? "auto" : "none", // Disable interaction
                  
                }}
                onClick={() => {
                  if (!item?.isAvailable) return;
                  setime(item?.deliveryTime);
                  onChange(name,item?.deliveryTime);
                  handleClose();
                }}
              >
                <Typography className="text" sx={{textAlign:"center"}}>{index == 0 ? 'As Soon As Possible' : item?.deliveryTime}</Typography>
              </Box>
            </Tooltip>
          ))}
          </>
        </Box>
      </Box>
    </Popover>
  );
};

export default TimeSlots;
